module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.User_Login .Form":{"hooks.onStartInit":[{"value":function () {
this.handleEvent(this.rwom1(this.getOption('container')), 'addedToDom', function (o, scope) {
scope.addDomHandler({
event: 'paste',
target: ['input[type=text]', 'input[type=password]'],
callback: function (el) {
setTimeout(function () {
el.value = fox.trim(el.value);
}, 1);
}
}, 'trimInputs');
});
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101014},"path":"~.User_Login .Form","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/trimLoginFields.js
// module id = 740
// module chunks = 4